export default {
    LOGIN_IN(state, token) {
        state.UserToken = token
    },
    LOGIN_OUT(state, token) {
        state.UserToken = ''
    },
    DE_WEIGHT(state,array) {
        
    }
}